// @ts-ignore insufficient imports from lib
import { RichTreeViewProApiRef } from "@mui/x-tree-view-pro/RichTreeViewPro/RichTreeViewPro.types";
import { isNotNil } from "ramda-adjunct";
import React, { useCallback, useMemo, useState } from "react";

export const useMigrationSelection = ({
  onChange,
  apiRef,
}: {
  onChange: (arg: { jobIds: string[]; positionIds: string[]; transportTripIds: string[] }) => void;
  apiRef: RichTreeViewProApiRef;
}) => {
  const [selectedTrips, setSelectedTrips] = useState<string[]>([]);
  const [selectedJobs, setSelectedJobs] = useState<string[]>([]);
  const [selectedPositions, setSelectedPositions] = useState<string[]>([]);

  const selected = useMemo(
    () => [
      ...selectedJobs.map((id) => `Job:${id}`),
      ...selectedPositions.map((id) => `Position:${id}`),
      ...selectedTrips.map((id) => `TransportTrip:${id}`),
    ],
    [selectedJobs, selectedPositions, selectedTrips]
  );

  const onSelectedChange = useCallback(
    (newSelected: { jobIds: string[]; positionIds: string[]; transportTripIds: string[] }) => {
      setSelectedJobs(newSelected.jobIds);
      setSelectedPositions(newSelected.positionIds);
      setSelectedTrips(newSelected.transportTripIds);
      onChange(newSelected);
    },
    [onChange]
  );

  const handleSelectedItemsChange = useCallback<(event: React.SyntheticEvent | null, itemIds: string[]) => void>(
    (_, items) => {
      const selectedMap = items
        .filter((item) => apiRef.current?.getItem(item).selectable)
        .map((item) => apiRef.current?.getItem(item).entity)
        .filter(
          (item): item is { type: "Job" | "Position" | "TransportTrip"; id: string } =>
            isNotNil(item) && item.type !== "Shift"
        )
        .reduce<Record<"Job" | "Position" | "TransportTrip", string[]>>(
          (acc, item) => ({ ...acc, [item.type]: [...(acc[item.type] ?? []), item.id] }),
          { Job: [], Position: [], TransportTrip: [] }
        );

      setSelectedJobs(selectedMap["Job"] ?? []);
      setSelectedPositions(selectedMap["Position"] ?? []);
      setSelectedTrips(selectedMap["TransportTrip"] ?? []);
      onChange({
        jobIds: selectedMap["Job"] ?? [],
        positionIds: selectedMap["Position"] ?? [],
        transportTripIds: selectedMap["TransportTrip"] ?? [],
      });
    },
    [apiRef, onChange]
  );
  return { onSelectedChange, handleSelectedItemsChange, selected };
};
